export default "__VITE_ASSET__DgbdbVoU__"